import { AwardCardProps } from '@/types/franchise.type';

export default function AwardCard({
  awardKor,
  awardEng,
  rank,
}: AwardCardProps) {
  return (
    <div className="desktop:justify-center desktop:w-screen desktop:ml-4 flex w-full flex-col items-center justify-start pt-22 text-[#9D7D4B]">
      <span className="typo-32 pb-7 font-bold">AWARDS</span>
      <span className="typo-18 pb-4 font-medium">{awardEng}</span>
      <span className="typo-36 pb-11.5 text-center leading-10 font-bold whitespace-pre-line">
        {awardKor}
      </span>
      <span className="text-[80px] leading-none font-black">{rank}</span>
    </div>
  );
}
